<h2 mat-dialog-title>
  <mat-icon svgIcon="image"></mat-icon>
  {{ header }}
</h2>
<button class="btn-close btn-icon" (click)="onClickCloseDialog()">
  <mat-icon class="material-icons">close</mat-icon>
</button>
<mat-dialog-content class="image-dialog">
  @if (editMode && hideUpload) {
    <div class="align-center margin--bottom-m">
      <button mat-raised-button color="primary" (click)="hideUpload = false">Upload nyt billede</button>
    </div>
  }
  @if (editMode && !hideUpload) {
    <div class="form-row">
      <div class="image-dialog__upload">
        @if (previewImageSafeUrl && fileToUpload) {
          <div class="image-dialog__preview">
            <img [src]="previewImageSafeUrl" class="image-dialog__preview-image" />
          </div>
        }
        @if (showUnsavedPreviewWarning) {
          <ok-feedback-info> Du har et billede i preview som ikke er uploaded. </ok-feedback-info>
        }

        <label for="connector-image" class="tiny_text">Upload billede af ladepunkt</label>
        <div class="image-dialog__input">
          <input
            type="file"
            id="connector-image"
            name="connector-image"
            class="hidden"
            accept="image/jpeg, image/jpg"
            (change)="handleFileInput($event)"
            #fileUpload />
          <button mat-stroked-button color="secondary" (click)="fileUpload.click()">
            <mat-icon class="material-icons">attach_file</mat-icon>
            Vælg fil
          </button>
          @if (fileUpload) {
            <span class="image-dialog__filename tiny-text ellipsis">{{ fileToUpload?.name }}</span>
          }
          @if (this.fileToUpload) {
            <span class="margin--left-auto">
              <button mat-icon-button (click)="clearPreview()">
                <mat-icon class="material-icons">close</mat-icon>
              </button>
            </span>
          }
        </div>
        <div class="tiny-text red margin--top-xs error-message">{{ errorMessage }}</div>
        @if (!errorMessage) {
          <div class="tiny-text margin--top-xs">Tilladte filtyper: {{ allowedFileExtensions.join(', ') }}</div>
        }
      </div>
    </div>

    <div class="form-row">
      <mat-form-field>
        <mat-label>Billede er taget denne dato</mat-label>
        <input matInput [matDatepicker]="picker" readonly [max]="todayDate" (dateChange)="changeDate($event)" (click)="picker.open()" />
        <mat-datepicker #picker></mat-datepicker>
        <button matIconSuffix mat-icon-button (click)="picker.open()">
          <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#calendar-s"></use></svg>
        </button>
      </mat-form-field>
    </div>
    <div class="form-row flex">
      <button
        mat-flat-button
        class="margin--left-auto"
        color="primary"
        (click)="uploadSelectedFile()"
        [disabled]="!fileToUpload || topLoaderService.loading || !pictureTakenDate">
        Upload
      </button>
    </div>
  }

  <div class="image-dialog__image-wrap">
    @if (pictureOutdated && !hideImage) {
      <ok-feedback-info> Billedet er mere end 6 måneder gammelt </ok-feedback-info>
    }
    <img class="image-dialog__image" [src]="src" (error)="onImageError()" [class.image-dialog__image--hide]="hideImage" />
    @if (pictureTakenDate) {
      <p>Billedet er taget: {{ pictureTakenDate | date: 'dd/MM/yyyy' }}</p>
    }
  </div>
</mat-dialog-content>
<mat-dialog-actions>
  @if (!editMode) {
    <button mat-flat-button color="primary" (click)="hideUpload = false; editMode = true; header = 'Tilføj/rediger billede'">
      <svg class="icon-20"><use href="assets/images/ok-icons-sprite.svg#calendar-s"></use></svg>
      Tilføj/rediger billede
    </button>
  }
  <button mat-stroked-button (click)="onClickCloseDialog()">Luk</button>
</mat-dialog-actions>
